import { CancelOutlined } from "@mui/icons-material";
import { Alert, AlertTitle, Button, Container, IconButton, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { useRef, useState } from "react";
import { FaPlus, } from "react-icons/fa";
import Loadingspinner from "../Components/loading";
import { getsessionuser, setsessionuser } from "../Utils/sessions";
import { Changesharingstatusurl } from "../Utils/urls";



const Yourprofile = ({ onsuccessfund, onfailfund, oncancelfund }) => {
    const user = getsessionuser()

    //basics
    const [error, seterror] = useState('');
    const [success, setsuccess] = useState('');

    const [loading, setloading] = useState(false);

    //change sharing status
    const changesharing = () => {
        setloading(true)
        seterror(null)
        const status = user?.sharingstatus == 1 ? 0 : 1;
        axios.post(Changesharingstatusurl, {
            status: status,
            id: user.id
        }).then(response => {
            setloading(false)
            if (!response.data.error) {
                user.sharingstatus = status
                setsessionuser(user)
                setsuccess("Updated successfully")
                setTimeout(() => {
                    setsuccess()
                    onsuccessfund()
                }, 3000);
            } else {
                seterror(response.data.message)
            }
            // 
        }).catch(error => {
            setloading(false)
            seterror("Sorry an error occurred,try again later");
        });

    }



    return (
        <Container sx={{
            backgroundColor: "white",
            borderRadius: 5,
            marginTop: 5,
            padding: 4,
        }} maxWidth="sm">
            <div style={{ position: "relative" }}>
                <div style={{ position: "absolute", right: 5,zIndex:5 }}>
                    <IconButton aria-label="delete" onClick={() => oncancelfund()}>
                        <CancelOutlined />
                    </IconButton>
                </div>
            </div>
            <div className="overflowdivwithoutscroll">
                {error?.length > 0 &&
                    <Alert severity="error">
                        <AlertTitle>Error</AlertTitle>
                        {error} — <strong>check it out!</strong>
                    </Alert>}
                {success?.length > 0 &&
                    <Alert severity="success">
                        <AlertTitle>Success</AlertTitle>
                        {success}
                    </Alert>}
                {loading && <Loadingspinner />}
                <div style={{ padding: 5 }}>
                    <Container maxWidth="md" className="containerwithshadow" style={{ marginTop: 30 }}>

                        <Typography sx={{ fontWeight: "bold" }}>
                            Your profile
                        </Typography>
                        <div style={{ marginTop: 30, flexWrap: "wrap" }}>
                            <div style={{ marginBottom: 15 }}>
                                <div style={{ fontSize: 15, width: "18%", marginTop: 5, textAlign: "left" }}>
                                    Username:
                                </div>
                                <TextField
                                    id="outlined-basic"
                                    sx={{ maxHeight: 20, marginBottom: 2, width: "80%", borderWidth: 0 }}
                                    disabled
                                    value={user?.username}
                                    FormHelperTextProps={{ fontSize: 10 }}
                                    inputProps={{ fontSize: 10 }}
                                    type={"tel"}
                                    variant="outlined" size="small" /><br />
                            </div>
                            <div style={{ marginBottom: 15 }}>
                                <div style={{ fontSize: 15, width: "18%", marginTop: 5, textAlign: "left" }}>
                                    Bio:
                                </div>
                                <TextField
                                    id="outlined-basic"
                                    sx={{ maxHeight: 20, marginBottom: 2, width: "80%" }}
                                    disabled
                                    value={user?.bio}
                                    FormHelperTextProps={{ fontSize: 10 }}
                                    inputProps={{ fontSize: 10 }}
                                    type={"tel"}
                                    variant="outlined" size="small" /><br />
                            </div>
                            <div style={{ marginBottom: 15 }}>
                                <div style={{ fontSize: 15, width: "18%", marginTop: 5, textAlign: "left" }}>
                                    Gender:
                                </div>
                                <TextField
                                    id="outlined-basic"
                                    sx={{ maxHeight: 20, marginBottom: 2, width: "80%" }}
                                    disabled
                                    value={user?.gender}
                                    FormHelperTextProps={{ fontSize: 10 }}
                                    inputProps={{ fontSize: 10 }}
                                    type={"text"}
                                    variant="outlined" size="small" /><br />
                            </div>
                            <div style={{ marginBottom: 15 }}>
                                <div style={{ fontSize: 15, width: "18%", marginTop: 5, textAlign: "left" }}>
                                    Age:
                                </div>
                                <TextField
                                    id="outlined-basic"
                                    sx={{ maxHeight: 20, marginBottom: 2, width: "80%" }}
                                    disabled
                                    value={user?.age}
                                    FormHelperTextProps={{ fontSize: 10 }}
                                    inputProps={{ fontSize: 10 }}
                                    type={"number"}
                                    variant="outlined" size="small" /><br />
                            </div>
                            <div style={{ marginBottom: 15 }}>
                                <div style={{ fontSize: 15, width: "18%", marginTop: 5, textAlign: "left" }}>
                                    Course:
                                </div>
                                <TextField
                                    id="outlined-basic"
                                    sx={{ maxHeight: 20, marginBottom: 2, width: "80%" }}
                                    disabled
                                    value={user?.course}
                                    FormHelperTextProps={{ fontSize: 10 }}
                                    inputProps={{ fontSize: 10 }}
                                    type={"text"}
                                    variant="outlined" size="small" /><br />
                            </div>
                            <div style={{ marginBottom: 15 }}>
                                <div style={{ fontSize: 15, width: "18%", marginTop: 5, textAlign: "left" }}>
                                    Hostel:
                                </div>
                                <TextField
                                    id="outlined-basic"
                                    sx={{ maxHeight: 20, marginBottom: 2, width: "80%" }}
                                    disabled
                                    value={user?.hostel}
                                    FormHelperTextProps={{ fontSize: 10 }}
                                    inputProps={{ fontSize: 10 }}
                                    type={"text"}
                                    variant="outlined" size="small" /><br />
                            </div>
                            <div style={{ marginBottom: 15 }}>
                                <div style={{ fontSize: 15, width: "18%", marginTop: 5, textAlign: "left" }}>
                                    Budget:
                                </div>
                                <TextField
                                    id="outlined-basic"
                                    sx={{ maxHeight: 20, marginBottom: 2, width: "80%" }}
                                    disabled
                                    value={user?.budget}
                                    FormHelperTextProps={{ fontSize: 10 }}
                                    inputProps={{ fontSize: 10 }}
                                    type={"number"}
                                    variant="outlined" size="small" /><br />
                            </div>
                            <div style={{ height: 40, position: "relative" }}>
                                <p align="middle">
                                    <Button onClick={() => changesharing()} variant="contained" sx={{ height: 30, fontSize: 12, marginRight: 2 }}>{user?.sharingstatus == 1 ? "STOP SHARING" : "START SHARING"}</Button><br /><br />
                                    <text style={{ color: "red", fontSize: 10 }}>
                                        Note: You are advised to take precaution
                                        of information you share and your
                                        interactions with the people on the app.
                                        DO NOT send money to strangers or meet them
                                        in secluded areas. Report any suspicious
                                        activity to the Eazistey Admin.
                                    </text>
                                </p>

                            </div>

                        </div>
                    </Container>
                </div>
            </div>
        </Container>
    )
}

export default Yourprofile;